import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Gruppe } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { AusstallenDialogComponent } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/schweine/ausstallen-dialog/ausstallen-dialog.component';
import { TodMeldenDialogComponent } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/schweine/tod-melden-dialog/tod-melden-dialog.component';
import { UmstallenDialogComponent } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/schweine/umstallen-dialog/umstallen-dialog.component';
import { ZeitslotBuchenDialogComponent } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/schweine/zeitslot-buchen-dialog/zeitslot-buchen-dialog.component';

@Component({
    selector: 'kiene-gruppe-schwein-popup-dialog',
    templateUrl: './gruppe-schwein-popup-dialog.component.html',
    styleUrls: ['./gruppe-schwein-popup-dialog.component.scss'],
})
export class GruppeSchweinPopupDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<GruppeSchweinPopupDialogComponent>,
        @Inject(MAT_DIALOG_DATA) protected gruppe: Gruppe,
        private dialog: MatDialog,
        private _router: Router,
    ) {}

    public umstallen(): void {
        this.dialog
            .open(UmstallenDialogComponent, { data: this.gruppe })
            .afterClosed()
            .subscribe({
                next: result => {
                    if (result) {
                        this.dialogRef.close();
                    }
                },
            });
    }

    public ausstallen(): void {
        this.dialog
            .open(AusstallenDialogComponent, { data: this.gruppe })
            .afterClosed()
            .subscribe({
                next: result => {
                    if (result) {
                        this.dialogRef.close();
                    }
                },
            });
    }

    public todMelden(): void {
        this.dialog
            .open(TodMeldenDialogComponent, { data: this.gruppe })
            .afterClosed()
            .subscribe({
                next: result => {
                    if (result) {
                        this.dialogRef.close();
                    }
                },
            });
    }

    public gruppenInfo(): void {
        this._router.navigate(['/gruppen', 'schweine-gruppen', this.gruppe.gruppe_id]).then();
        this.dialogRef.close();
    }

    schlachten() {
        const dialogRef = this.dialog.open(ZeitslotBuchenDialogComponent, { data: this.gruppe, minWidth: '1200px' });
        dialogRef.afterClosed().subscribe(res => {
            this.dialogRef.close(res);
        });
    }
}
